/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class ReviewConfigurationService extends services.DataService<Wars.Domain.Model.Reviews.ReviewConfiguration> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService,private $http:angular.IHttpService) {
            super(injectedBreeze, $q);
        }

        public createReviewConfiguration(): Wars.Domain.Model.Reviews.ReviewConfiguration {
            var config = this.createNewEntity<Wars.Domain.Model.Reviews.ReviewConfiguration>("ReviewConfiguration");
            config.uniqueIdentifier = UtilityService.generateGuidComb();
            return config;
        }

        public createReviewReminder(): Wars.Domain.Model.Reviews.ReviewReminder{
            return <Wars.Domain.Model.Reviews.ReviewReminder>this.createNewEntity("ReviewReminder");
        }

        public getExtensibleUserRepositories(): angular.IPromise<string[]> {
            var d = this.$q.defer();

            this.$http.get('./api/ExtensibleComponent/GetExternalUserRepositories').then(result => {
                d.resolve(result.data);
            });

            return d.promise;
        }

        public getReviewConfigurations(processId?: string): angular.IPromise<Wars.Domain.Model.Reviews.ReviewConfiguration[]> {
            let query = this.breezeModule.EntityQuery
                .from("ReviewConfigurationsLazy");

            if (processId) {
                query = query.where('processConfiguration_id', '==', processId);
            } else {

                query = query.where('processConfiguration_id', '==', null);
            }
            query = query.expand("securityMatrix, " +
                "reviewReminders, " +
                "codeGroup.codes, " +
                "systemReviewGroup, " +
                "documentConfiguration, " +
                "canRemoveSecurityMatrix, " +
                "commentThreadConfiguration.canCommentSecurityMatrix, " +
                "commentThreadConfiguration.canDeleteSecurityMatrix, " +
                "commentThreadConfiguration.canAddDocumentSecurityMatrix, " +
                "commentThreadConfiguration.documentConfiguration.canDownloadSecureDocumentSecurityMatrix, " +
                "commentThreadConfiguration.documentConfiguration.canSecureDocumentSecurityMatrix, " +
                "commentThreadConfiguration.documentConfiguration.myAvailableDocumentTypes.mySystemCode, " +
                "commentThreadConfiguration.canViewDeletedCommentsSecurityMatrix, " +
                "commentThreadConfiguration.commentEmailConfiguration," +
                "commentThreadConfiguration.canCommentSecurityMatrix").orderBy("name");

            return this.executeQuery(query);
        }
    }
}

warsApp.registerService('ReviewConfigurationService', ['breeze', '$q', '$http']);